module.exports = __webpack_public_path__ + "media/images/icons/outlined/exception-048858dce2aecd7b684f586fc00124ee.svg";